<template>
  <div class="d-flex col-lg-12 justify-content-center">
    <h1 class="font-raleway-bold-30 p-4 m-4">Welcome to Fieldbeat Tools</h1>
  </div>    
</template>
  
  <script>
  export default {
    name: 'IndexPage',
    components:{
    }
  }
  
  </script>
  
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  /* Estilo para el sidebar */

  </style>
  